import React from "react";
import { Form, Row, Col, Button } from "react-bootstrap";
import { Edit } from "@material-ui/icons";
import { currencyFormat } from "./../../Common/Common";
import * as code from "./../../../config/Constants";

class InviteReview extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      user: props.getUserData(),
    };
  }

  /**
   * @desc jump to other step for edit information
   */
  stepChange(step) {
    this.props.jumpToStep(step);
  }

  render() {
    return (
      <div className="step-content last-step">
        <Row>
          <Col>
            <h4 className="title-blue mb-3">Personal Information</h4>
          </Col>
          <Col className="col-auto">
            <Button
              variant="transparent"
              className="edit-icn p-0"
              onClick={() => this.stepChange(0)}
            >
              <Edit />
            </Button>
          </Col>
        </Row>

        <Form className="form-sm">
          <Row>
            <Col xs={12} sm={6}>
              <Form.Group controlId="">
                <Form.Label>First Name</Form.Label>
                <p className="form-val">{this.state.user.firstname}</p>
              </Form.Group>
            </Col>
            <Col xs={12} sm={6}>
              <Form.Group controlId="">
                <Form.Label>Last Name</Form.Label>
                <p className="form-val">{this.state.user.lastname}</p>
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col xs={12} sm={6}>
              <Form.Group controlId="">
                <Form.Label>Email ID</Form.Label>
                <p className="form-val email-case">{this.state.user.email}</p>
              </Form.Group>
            </Col>
            <Col xs={12} sm={6}>
              <Form.Group controlId="">
                <Form.Label>Recovery Email ID</Form.Label>
                <p className="form-val email-case">
                  {this.state.user.recoveryEmail}
                </p>
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col xs={12} sm={6}>
              <Form.Group controlId="">
                <Form.Label>Mobile No.</Form.Label>
                <p className="form-val">{this.state.user.mobileNumber}</p>
              </Form.Group>
            </Col>
            <Col xs={12} sm={6}>
              <Form.Group controlId="">
                <Form.Label>Phone No. (Office)</Form.Label>
                <p className="form-val">
                  {this.state.user.otherNumber !== ""
                    ? this.state.user.otherNumber
                    : "-"}
                </p>
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col xs={12} sm={6}>
              <Form.Group controlId="">
                <Form.Label>How you know about us?</Form.Label>
                <p className="form-val">
                  {this.state.user.knowAboutUs !== ""
                    ? this.state.user.knowAboutUs
                    : "-"}
                </p>
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col xs={12} sm={6}>
              <Form.Group controlId="">
                <Form.Label>Facebook URL</Form.Label>
                <p className="form-val">
                  {this.state.user.socialMediaHandles.facebook}
                </p>
              </Form.Group>
            </Col>
            <Col xs={12} sm={6}>
              <Form.Group controlId="">
                <Form.Label>Instagram URL</Form.Label>
                <p className="form-val">
                  {this.state.user.socialMediaHandles.instagram}
                </p>
              </Form.Group>
            </Col>
          </Row>
        </Form>

        <Row className="mt-2">
          <Col>
            <h4 className="title-blue mb-3">Studio Information</h4>
          </Col>
          <Col className="col-auto">
            <Button
              variant="transparent"
              className="edit-icn p-0"
              onClick={() => this.stepChange(1)}
            >
              <Edit />
            </Button>
          </Col>
        </Row>

        <Form className="form-sm">
          <Row>
            <Col xs={12}>
              <Form.Group controlId="">
                <Form.Label>Studio Name</Form.Label>
                <p className="form-val">
                  {this.state.user.companyInformation.name}
                </p>
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col xs={12}>
              <Form.Group controlId="">
                <Form.Label>Studio Website</Form.Label>
                <p className="form-val">
                  {this.state.user.companyInformation.website !== ""
                    ? this.state.user.companyInformation.website
                    : "-"}
                </p>
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col xs={12}>
              <Form.Group controlId="">
                <Form.Label>Studio Address</Form.Label>
                <p className="form-val email-case">
                  {this.state.user.companyInformation.address}
                </p>
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col xs={12} sm={4}>
              <Form.Group controlId="">
                <Form.Label>Zip Code</Form.Label>
                <p className="form-val">
                  {this.state.user.companyInformation.zipcode}
                </p>
              </Form.Group>
            </Col>
            <Col xs={12} sm={4}>
              <Form.Group controlId="">
                <Form.Label>City</Form.Label>
                <p className="form-val">
                  {this.state.user.companyInformation.city}
                </p>
              </Form.Group>
            </Col>
            <Col xs={12} sm={4}>
              <Form.Group controlId="">
                <Form.Label>State</Form.Label>
                <p className="form-val">
                  {this.state.user.companyInformation.state}
                </p>
              </Form.Group>
            </Col>
          </Row>

          {/* {localStorage.getItem(code.IS_STRIPE_ENABLED) === "true" ? (
            <>
              <Row>
                <Col>
                  <h4 className="title-blue mb-3">Plan Information</h4>
                </Col>
                <Col className="col-auto">
                  <Button
                    variant="transparent"
                    className="edit-icn p-0"
                    onClick={() => this.stepChange(2)}
                  >
                    <Edit />
                  </Button>
                </Col>
              </Row>
              <Row>
                <Col xs={12} sm={4}>
                  <Form.Group controlId="">
                    <Form.Label>Product Name</Form.Label>
                    <p className="form-val">{this.state.user.productName}</p>
                  </Form.Group>
                </Col>
                <Col xs={12} sm={4}>
                  <Form.Group controlId="">
                    <Form.Label>Billing Period</Form.Label>
                    <p className="form-val">
                      {this.state.user.interval === "month"
                        ? "Monthly"
                        : "Yearly"}
                    </p>
                  </Form.Group>
                </Col>
                <Col xs={12} sm={4}>
                  <Form.Group controlId="">
                    <Form.Label>Total Price</Form.Label>
                    <p className="form-val">
                      {currencyFormat(this.state.user.amount)}
                    </p>
                  </Form.Group>
                </Col>
              </Row>
            </>
          ) : (
            ""
          )} */}
        </Form>
      </div>
    );
  }
}

export default InviteReview;
